import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'
import interpolateRouteUtil from 'modules/routes/utils/interpolate'
import getSlugExerciseNameUtil from 'modules/exercise/utils/get-slug/index.js'

export const getExerciseUrl = ({ exerciseName, exerciseId, location, isVideoUrl }) => {
  let slug
  if (exerciseName) {
    slug = getSlugExerciseNameUtil(exerciseName)
  }

  let url = location.origin + interpolateRouteUtil(
    ROUTE_PATH.VIEW_EXERCISE_SLUG,
    {
      id: exerciseId,
      slug
    }
  )

  if (isVideoUrl) {
    url += '-video'
  }

  return url
}
